module.exports = __webpack_public_path__ + "static/media/girl_standing.2bfa402f.svg";